import React from "react";
import "./DrShrutiEducation.css";
const DrShrutiEducation = () => {
  
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "MedicalOrganization",
    name: "Krisara Gastro and Liver Clinic",
    url: "https://krisaragastro.com/",
    logo: "https://i.ibb.co/HDcnBZt3/Rectangle-76.png",
    image: "https://i.ibb.co/HDcnBZt3/Rectangle-76.png",
    telephone: "+91 7569541532",
    email: "gastro@krisara.com",
    address: {
      "@type": "PostalAddress",
      streetAddress:
        "3rd Floor, Fairmount Square, Pet Basheerabad, Quthbullapur, Kompally",
      addressLocality: "Hyderabad",
      addressRegion: "Telangana",
      postalCode: "500014",
      addressCountry: "IN",
    },
    sameAs: [
      "https://www.facebook.com/krisaragastro",
      "https://www.instagram.com/krisaragastro",
    ],
  };

  return (
    <section className="drshruti-education">
      {/* Badge Image */}
      <img
        src="https://i.ibb.co/YF8ByrHf/pngtree-gold-luxury-certified-badge-with-red-ribbon-and-white-combination-color-vector-png-image-710.png" // <-- put your badge image here
        alt="Certified Badge - Best Gastroenterologist in Kompally Hyderabad - Krisara Gastro Clinic"
        className="education-badge"/>
      <div className="drshruti-education-container">
        <h2 className="drshruti-education-title">
          Educational Excellence & Qualifications
        </h2>
        {/* Medical Education */}
        <div className="drshruti-education-block">
          <h3 className="drshruti-education-subtitle">Medical Education</h3>
          <ul className="drshruti-education-list">
            <li>MBBS - Gandhi Medical College, Telangana (2009–2015)</li>
            <li>
              MD (Internal Medicine) - M.S. Ramaiah Medical College & Hospital,
              Bangalore (2016–2019)
            </li>
            <li>
              DM (Gastroenterology) - M.S. Ramaiah Medical College & Hospital,
              Bangalore (2019–2022)
            </li>
          </ul>
        </div>
        {/* Specialised Certifications */}
        <div className="drshruti-education-block">
          <h3 className="drshruti-education-subtitle">
            Specialised Certifications
          </h3>
          <ul className="drshruti-education-list">
            <li>W.I.S.E Accreditation for Endoscopic Ultrasound</li>
            <li>
              Advanced training in therapeutic endoscopy and
              hepato-pancreaticobiliary interventions
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};
export default DrShrutiEducation;